import { useState } from "react";
import { Switch } from "@mui/material";

import { CdmFinderFilters } from "./CdmFinderFilters";
import { CdmRecallFilters } from "./CdmRecallFilters";
import { CdmRegisterFilters } from "./CdmRegisterFilters";
import styles from "./ReportsFilters.module.css";
import { StandardFilters } from "./StandardFilters";

// Green MUI switch, matching the rest of the app (e.g. AddMedicationForm).
const SWITCH_SX = {
  padding: "6px",
  marginRight: "-6px",
  borderRadius: "16px",
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "var(--green-800)",
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": { backgroundColor: "#fff" },
  "& .MuiSwitch-track": {
    backgroundColor: "#a0a0a0",
    opacity: 0.5,
    padding: 0,
    borderRadius: "16px",
  },
};

export const ReportsFilters = ({ reportType, filters, onFilterChange }) => {
  // CDM Finder can be driven two ways: guided "Programme + Condition" (default)
  // or the grouped "Finder" dropdown (spec p.18). Lives here so the switch can
  // sit above the filters card. Flipping resets the finder selection.
  const [useGroupedFinder, setUseGroupedFinder] = useState(false);

  const handleFinderModeToggle = () => {
    setUseGroupedFinder((prev) => !prev);
    onFilterChange("finderKey", "");
    onFilterChange("finderProgramme", "");
    onFilterChange("finderReviewType", "");
    onFilterChange("finderConditions", []);
    onFilterChange("minEgfr", "");
    onFilterChange("maxEgfr", "");
  };

  if (reportType === "cdm-finder") {
    return (
      <>
        <div className={styles.finderModeRow}>
          <span className={styles.finderModeLabel}>Grouped finder list</span>
          <Switch
            checked={useGroupedFinder}
            onChange={handleFinderModeToggle}
            inputProps={{ "aria-label": "Grouped finder list" }}
            sx={SWITCH_SX}
          />
        </div>
        <div className={styles.filtersWrapper}>
          <CdmFinderFilters
            filters={filters}
            onFilterChange={onFilterChange}
            useGroupedFinder={useGroupedFinder}
          />
        </div>
      </>
    );
  }

  if (reportType === "cdm-recall") {
    return (
      <div className={styles.filtersWrapper}>
        <CdmRecallFilters filters={filters} onFilterChange={onFilterChange} />
      </div>
    );
  }

  if (reportType === "cdm-register") {
    return (
      <div className={styles.filtersWrapper}>
        <CdmRegisterFilters filters={filters} onFilterChange={onFilterChange} />
      </div>
    );
  }

  return (
    <div className={styles.filtersWrapper}>
      <div className={styles.filtersGrid}>
        <StandardFilters
          reportType={reportType}
          filters={filters}
          onFilterChange={onFilterChange}
        />
      </div>
    </div>
  );
};
